import { IDataContext } from '../interfaces/IDataContext'
import { IRootState } from '../interfaces/IRootState'

export const initialDataContext: IDataContext = {
   state: null,
   setRootState: null,
   handleMessage: null,
}
export const GetInitialRootState = (): IRootState => ({
   accessToken: null,
   navigationExpanded: false,
   isLoading: false,
   message: null,
   demands: null,
   selectedDemands: [],
   subjects: [],
   organisationSizes: [],
   organisationTypes: [],
   leadershipPerspectives: [],
   snis_2007: [],
   snis_2025: [],
   initialLoading: true,
   isDashboard: false,
   processes: [],
   answerOptions: [],
   demandComplianceModuleDefinitions: [],
   clauses: [],
   selectedTab: 'activeDemands',
   expandedDemands: [],
   moveDemands: false,
   demandSearchQuery: '',
})
